<template>
  <div class="wrapper">
    <div class="content">
      <h1 class="mt-1">Privacy Policy</h1>
      <div class="marker"></div>
      <h5 class="mt-2">Effective date: October 1, 2020</h5>

      <h2>What information AEC Works collects and Why</h2>
      <p>
        In order to give you the best possible experience using AEC Works, we collect information
        from your interactions with our network. We use common internet technologies, such as
        cookies and web server logs. We collect this basic information from everybody, whether they
        have an account or not.
      </p>

      <p>The information we collect about all visitors to our website includes:</p>

      <ul class="tos-list">
        <li class="ml-1">
          <p>• The visitor’s browser type</p>
        </li>
        <li class="ml-1">
          <p>• Referring site</p>
        </li>
        <li class="ml-1">
          <p>• The date and time of each visitor request</p>
        </li>
        <li class="ml-1">
          <p>
            We also collect potentially personally-identifying information like Internet Protocol
            (IP) addresses.
          </p>
        </li>
      </ul>
      <p>We use this information to:</p>
      <ul class="tos-list">
        <li class="ml-1">
          <p>• Provide, test, improve, promote and personalize AEC Works Services</p>
        </li>
        <li class="ml-1">
          <p>• Fight spam and other forms of abuse</p>
        </li>
        <li class="ml-1">
          <p>
            • Generate aggregate, non-identifying information about how people use AEC Works
            Services
          </p>
        </li>
      </ul>
      <p>
        In order for you to create an account on AEC Works and use our Services, we need to collect
        and process certain information. Depending on your use of the Services, that may include:
      </p>
      <ul class="tos-list">
        <li class="ml-1">
          <p>
            • Communications you send to us (for example, when you ask for support, send us
            questions or comments, or report a problem);
          </p>
        </li>
        <li class="ml-1">
          <p>
            • Information that you submit on or to AEC Works in the form of reactions, comments, or
            messages to other users;
          </p>
        </li>
        <li class="ml-1">
          <p>
            • The email address associated with your LinkedIn account, if you choose to sign up
            using your LinkedIn credentials. AEC Works will also request permission to access
            additional information (these permissions are governed by LinkedIn's privacy policies
            and can be managed through your LinkedIn privacy settings). We never post anything to
            your LinkedIn without your permission.
          </p>
        </li>
        <li class="ml-1">
          <p>
            • The email address associated with your GitHub account, if you choose to sign up using
            your Github credentials. AEC Works will also request permission to access additional
            information (these permissions are governed by GitHub’s privacy policies and can be
            managed through your GitHub privacy settings). We never post anything to your GitHub
            without your permission.
          </p>
        </li>
        <li class="ml-1">
          <p>
            • You also have the option to give us more information if you want to, and this may
            include “User Personal Information.”
          </p>
        </li>
      </ul>
      <h2>Information Disclosure</h2>
      <p>
        We do not share, sell, rent, or trade User Personal Information with third parties for
        commercial purposes.
      </p>
      <p>
        We do share certain aggregated, non-personally identifying information with others about how
        our users, collectively, use AEC Works.
      </p>
      <p>
        We may share User Personal Information with a limited number of third party vendors who
        process it on our behalf to provide or improve our service, and who have agreed to privacy
        restrictions similar to our own Privacy Statement. Our third party vendors are listed below.
      </p>
      <h2>Data Storage</h2>
      <p>
        AEC Works uses third-party vendors and hosting partners for hardware, software, networking,
        storage, and related technology we need to run AEC Works. By using AEC Works Services, you
        authorize AEC Works to transfer, store, and use your information in the United States and
        any other country where we operate. All service providers and third-party vendors are
        required to meet our data protection standards.
      </p>
      <h2>Site monitoring</h2>
      <p>
        AEC Works uses a variety of third-party services to diagnose errors and improve the
        performance of our site. We aim to minimize the amount of personal information shared, but
        the information may include your IP address or other identifying information. All service
        providers and third-party vendors are required to meet our data protection standards.
      </p>
      <h2>Third-Party Embeds</h2>
      <p>
        Some of the content that you see displayed on AEC Works is not hosted by AEC Works. These
        “embeds” are hosted by a third-party and embedded in AEC Works. For example: Twitter tweets
        that appear within a AEC Works post. These files send data to the hosted site just as if you
        were visiting that site directly (for example, when you load a AEC Works post page with a
        Twitter tweet embedded in it, Twitter receives data about your activity). AEC Works does not
        control what data third parties collect in cases like this, or what they will do with it.
        Third-party embeds on AEC Works are not covered by this privacy policy; they are covered by
        the privacy policy of the third-party service. Be mindful when interacting with these
        services.
      </p>
      <h2>Tracking & Cookies</h2>
      <p>
        We use browser cookies and similar technologies to recognize you when you return to our
        Services. Third-party vendors may also use cookies for various reasons.
      </p>
      <p>
        AEC Works uses a specific cookie in order to facilitate the use of Google Universal
        Analytics for users logged-in to the Applications or the Platforms (“Logged-In User"). If
        you are a Logged-In User, AEC Works may use your AEC Works user ID in combination with
        Google Universal Analytics and Google Analytics to track and analyze the pages of the
        Services you visit. We do this only to better understand how you use the Website and the
        other Services, with a view to offering improvements for all AEC Works users; and to tailor
        our business and marketing activities accordingly, both generally and specifically to you.
        Google Analytics cookies do not provide AEC Works with any Personal Information. You can
        prevent Google Analytics from recognizing you on return visits to this site by disabling
        cookies on your browser.
      </p>
      <p>
        You may opt-out of this feature by installing the Google Analytics Opt-out Browser Add-on,
        by setting your web browser to refuse cookies, or by setting your browser to alert you when
        cookies are being sent. If you do so, note that some parts of the Site may not function
        properly.
      </p>
      <h2>Data Security</h2>
      <p>
        We use encryption (HTTPS/TLS) to protect data transmitted to and from our site. However, no
        data transmission over the Internet is 100% secure, so we can’t guarantee security. You use
        the Service at your own risk, and you’re responsible for taking reasonable measures to
        secure your account.
      </p>
      <h2>Administrative Emails from AEC Works</h2>
      <p>
        Sometimes we’ll send you emails about your account, service changes or new policies. You
        can’t opt out of this type of “transactional” email (unless you delete your account).
      </p>
      <p>
        When you interact with a transactional email sent from AEC Works (such as opening an email
        or clicking on a particular link in an email), we may receive information about that
        interaction.
      </p>
      <h2>Deleting Your Personal Information</h2>
      <p>
        You may request deletion of your personal information and account by emailing
        <a href="mailto:team@aec.works">team@aec.works.</a>
      </p>
      <p>
        To protect information from accidental or malicious destruction, we may maintain residual
        copies for a brief time period. But, if you delete your account, your information and
        content will be unrecoverable after that time.
      </p>
      <h2>Data Portability</h2>
      <p>
        If you would like to request a copy of your user data, please email
        <a href="mailto:team@aec.works">team@aec.works</a>
        .
      </p>
      <h2>Business Transfers</h2>
      <p>
        If we are involved in a merger, acquisition, bankruptcy, reorganization or sale of assets
        such that your information would be transferred or become subject to a different privacy
        policy, we’ll notify you in advance of any such change.
      </p>
      <h2>Changes to this Policy</h2>
      <p>
        We reserve the right to revise this Privacy Policy at any time. If we change this Privacy
        Policy in the future, we will post the revised Privacy Policy and update the “Effective
        Date,” above, to reflect the date of the changes.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo: {
    title: 'Privacy Policy',
  },
}
</script>
